

function boot() {
	setTimeout(function(){
		if (ieCheck())
		{
			ieResolve(document.querySelectorAll('[lazy-load]'));
			return true;

		}

		ieResolve(document.querySelectorAll('[critical]'));

		window.addEventListener("load", function() {
			resolveLazyLoad(document.querySelectorAll('[lazy-load]'));
		});

		window.addEventListener("scroll", function() {
			resolveLazyLoad(document.querySelectorAll('[lazy-load]'));
		});

		window.addEventListener("click", function() {
			resolveLazyLoad(document.querySelectorAll('[lazy-load]'));
		});
	}, 0);

}

function ieCheck() {
	var ua = window.navigator.userAgent;
	var trident = ua.indexOf("Trident/");

	var edge = ua.indexOf("Edge/");
	var edge_version = 0;

	if (edge > 0) {
		edge_version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// If Internet Explorer or Edge < 16, return true
	return (trident > 0 || (edge_version > 0 && edge_version < 16));
}

function isScrolledIntoView(elem) {
	let docViewTop = window.scrollY;
	let windowHeight = window.innerHeight;
	let elemTop = elem.getBoundingClientRect().top + document.body.scrollTop - windowHeight - 400;

	return (elemTop <= docViewTop);
}

function ieResolve(lazyElements) {
	Array.prototype.forEach.call(lazyElements, function (item) {
		resolve(item);
	});

	executeTasks();
}

let lazySettingTasks = [];

const objectFit = require("app/frontend/object-fit");

function executeTasks() {
	requestAnimationFrame(function(){
		if(lazySettingTasks.length > 0) {

			for(let i = 0; i < lazySettingTasks.length; i++) {
				lazySettingTasks[i]();
			}

			lazySettingTasks = [];
			objectFit(false);
		}
	});
}

function resolveLazyLoad(lazyElements) {
	Array.prototype.forEach.call(lazyElements, function(item){

	    if(item.getAttribute('lazy-loaded') || item.offsetParent === null) {
	        return;
        }

		if(isScrolledIntoView(item) || item.getAttribute('afterload')) {
		    resolve(item);
		}
	});

	executeTasks();
}

function resolve(item) {

	const fullSize = item.getAttribute('full') ?
		item.getAttribute('full') :
		item.getAttribute('src');
	const srcsetfull = item.getAttribute('srcsetfull');
	const cssbg = item.getAttribute('cssbg');

	lazySettingTasks[lazySettingTasks.length] = function(){
		item.setAttribute('lazy-loaded', 'true');
		item.removeAttribute('lazy-load');

		if (cssbg) {
			item.style.backgroundImage = 'url('+cssbg+')';
		}else if (fullSize) {
			if(srcsetfull) {
				item.setAttribute('srcset', srcsetfull);
			}
			item.setAttribute('src', fullSize);
		}
	};
}

module.exports = {
	boot,
	resolveLazyLoad,
    ieCheck,
	ieResolve,
}
